import React from 'react';
import clsx from 'clsx';

import Clickwrap from 'components/Clickwrap';

/* eslint-disable max-len */
/**
 * A component that renders a list of checkboxes from a list of options.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the checkbox inputs.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper fieldset.
 * @param {string} [props.labelClasses] - Additional CSS classes for the legend.
 * @param {string} props.label - The text to display for the legend.
 * @param {Array} props.options - An array of option objects.
 * @param {number} props.options[].id - The unique ID of the option.
 * @param {string} props.options[].optionLabel - The label for the option.
 * @param {boolean} props.options[].selected - Whether the option is selected.
 * @param {function(id: string, checked: boolean): void} props.handleOptionsChange - The function to call when a checkbox is changed.
 */
/* eslint-enable max-len */
export const ChooseMany = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  label,
  options,
  handleOptionsChange,
}) => {

  return (
    <fieldset
      className={clsx(wrapperClasses, 'custom-form-vield--choose-many')}
    >
      <legend
        className={labelClasses}
      >
        {label}
      </legend>
      <div className="custom-form-field__options-list">
        {options.map(({ id, optionLabel, selected }, index) => {
          return (
            <div className="custom-form-field__option">
              <Clickwrap
                key={`choose-many-${id}--${index}`}
                name={`choose-many-${id}--${index}`}
                type="checkbox"
                value={selected}
                checked={selected}
                onChange={(e) => handleOptionsChange(id, e.target.checked)}
                className={clsx(inputClasses, 'small')}
              />
              <label
                htmlFor={`choose-many-${id}--${index}`}
                className="custom-form-field__option-label"
              >
                {optionLabel}
              </label>
            </div>
          );
        })}
      </div>
    </fieldset>
  );
};
